<template>
  <section class="container">
    <div class="main">
      <div class="header">
        <h2>资源中心</h2>

      </div>
      <div>
        <ul class="mg-l-15">
          <li
            v-for="(item,index) in docList"
            :key="index">
            <a
              :href="item.path"
              class="blue text-decoration-none mg-b-16"
              target="_blank">{{item.name}}</a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
const env = require('../../../env')
export default {
  name: 'source',
  components:{
  },
  mixins: [MixinOptions,MixinRules],
  props:{
  },

  computed:{
    docList(){
      return[
        {
          name:'保单条款',
          path:'/doc/保单条款.pdf'
        },
        {
          name:'小册子',
          path:'/doc/小册子.pdf'
        },
        {
          name:'指定车辆型号',
          path:'/doc/指定车辆型号.pdf'
        },
        {
          name:'索偿书',
          path:'/doc/索偿书.pdf'
        }
      ]
    }
  },
  methods: {
  },
}
</script>
<style lang='scss' scoped>
.container{
  display: flex;
  padding: 0 70px;
  margin-top: 20px;
  min-height: calc(100vh - 150px);
  .main{
    margin-right: 30px;
    flex: 1;
    .header{
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      h2{
        padding: 0;
        font-weight: 600;
        font-size: 24px;
        color: #24292E;
      }
    }
  }
}
</style>
